<template>
  <div class="app-badge d-inline-block" :class="{ 'badge-circle': circle }">
    <b-badge
      v-if="visible"
      ref="badge"
      pill
      :variant="variant"
      class="b-badge"
      :class="{ [`b-badge-${size}`]: true }"
      @click="onClick"
    >
      <slot name="content">{{ content }}</slot>
    </b-badge>
    <div @click="onClick" ref="body">
      <slot />
    </div>
  </div>
</template>

<script>
const SIZE_XS = "xs";
const SIZE_SM = "sm";
const SIZE_MD = "md";
const SIZE_LG = "lg";

const ALIGN_END = "end";
const ALIGN_CENTER = "center";

export default {
  name: "AppBadge",
  props: {
    variant: {
      type: String,
      required: false,
      default: "primary",
    },
    content: {
      type: [String, Number],
      required: false,
      default: null,
    },
    size: {
      type: String,
      required: false,
      default: SIZE_MD,
      validator: value =>
        [SIZE_XS, SIZE_SM, SIZE_MD, SIZE_LG].indexOf(value) >= 0,
    },
    circle: {
      type: Boolean,
      required: false,
      default: false,
    },
    align: {
      type: String,
      required: false,
      default: ALIGN_END,
      validator: value => [ALIGN_CENTER, ALIGN_END].indexOf(value) >= 0,
    },
    visible: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  updated() {
    this.computeOffsets();
  },
  mounted() {
    this.computeOffsets();
    this.observer = new MutationObserver(() => {
      this.computeOffsets();
    });

    this.observer.observe(this.$refs.body, {
      childList: true,
      attributes: true,
      subtree: true,
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  computed: {
    body() {
      return this.$slots.default;
    },
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
    computeOffsets() {
      if (this.align === ALIGN_CENTER) {
        this.offsetY = Math.ceil(this.$refs.body.offsetWidth * 0.55);
        if (this.$refs.badge) {
          this.offsetX = Math.ceil(this.$refs.badge.offsetHeight * 0.3);
        }

        return;
      }

      this.offsetY = Math.ceil(this.$refs.body.offsetWidth * 0.8);
      if (this.$refs.badge) {
        this.offsetX = Math.ceil(this.$refs.badge.offsetHeight * 0.3);
      }
    },
  },
  data() {
    return {
      offsetY: 0,
      offsetX: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.app-badge {
  position: relative;
  width: 100%;

  &.badge-circle {
    .b-badge {
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .b-badge {
    position: absolute;
    top: 1rem;
    z-index: 1;

    &.b-badge-xs {
      font-size: 0.625rem;
    }
    &.b-badge-sm {
      font-size: 0.75rem;
    }
    &.b-badge-md {
      font-size: 0.87rem;
    }
    &.b-badge-lg {
    }
  }

  &.badge-circle {
    .b-badge-xs {
      font-family: $font-family-america;
      background-color: $white;
      font-weight: 400;
      line-height: 9px;
      min-height: 1rem;
      min-width: 1rem;
      font-size: 9px;
      color: $black;
      right: -11px;
      width: 1rem;
      height: 1rem;
      top: -14px;
    }
    .b-badge-sm {
    }
    .b-badge-md {
    }
    .b-badge-lg {
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>
